import { FestivalSkeletonWhiteBox } from "../../../../style/skeleton";
import { RabbitFestivalCompetitionsListWrapper } from "./style";

export const RabbitFestivalCompetitionsListSkeleton = () => {
  return (
    <RabbitFestivalCompetitionsListWrapper>
      {Array.from({ length: 5 }, (_, i) => (
        <FestivalSkeletonWhiteBox
          key={i}
          width="100%"
          height="210px"
          radius="8px"
        />
      ))}
    </RabbitFestivalCompetitionsListWrapper>
  );
};

export default RabbitFestivalCompetitionsListSkeleton;
